import "./index.less";
import { getAwsS3Data } from '@utils/api.js'
import { uploadToS3 } from '@utils/index.js'

class Dropdown {
  constructor(selector, options = {}) {
    this.dropdown = typeof selector === 'string' ? document.querySelector(selector) : selector;
    if (!this.dropdown) return;

    this.selected = this.dropdown.querySelector('.dropdown-selected');
    this.list = this.dropdown.querySelector('.dropdown-list');
    this.items = this.dropdown.querySelectorAll('.dropdown-item');
    this.placeholder = options.placeholder || 'Please Select';
    this.onSelect = options.onSelect || function () { };

    this.init();
  }

  init() {
    // 初始化显示文字
    const span = this.selected.querySelector('span');
    if (span && !span.textContent.trim()) span.textContent = this.placeholder;

    // 点击展开/关闭
    this.selected.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggleList();
    });

    // 点击选项
    this.items.forEach(item => {
      item.addEventListener('click', (e) => {
        const value = e.target.textContent.trim();
        this.selectItem(value, e.target);
      });
    });

    // 点击外部关闭
    document.addEventListener('click', () => this.closeList());
  }

  toggleList() {
    const isOpen = this.dropdown.classList.contains('open');
    document.querySelectorAll('.dropdown.open').forEach(d => d.classList.remove('open'));
    if (!isOpen) this.dropdown.classList.add('open');
  }

  closeList() {
    this.dropdown.classList.remove('open');
  }

  selectItem(value, target) {
    const span = this.selected.querySelector('span');
    if (span) {
      span.textContent = value;

      // 给选中状态添加类名 active
      span.classList.add('active');
    }

    // 清除旧选中项
    this.items.forEach(item => item.classList.remove('selected'));

    // 当前项加 selected 类
    if (target) target.classList.add('selected');

    this.onSelect(value, this.dropdown);
    this.closeList();
  }
}


(function () {
  document.addEventListener("DOMContentLoaded", function () {
    // Interested Products - 选择其他选项并输入自定义文本时，则自动填充到复选框值中
    const jpForm = document.querySelector('.csr-form');
    const chooseLabel = document.querySelector('.csr-form #chooseLabel');

    document.querySelectorAll('.dropdown').forEach(drop => {
      new Dropdown(drop, {
        placeholder: 'Please Select',
        onSelect: (value, el) => {
          drop.closest('.form-item').querySelector('.hidden input').value = value
        }
      });
    });

    const checkDom = document.querySelector('.csr-form .jky-checkbox-original');
    const submitDom = document.querySelector('.csr-form jds-button');
    checkDom.addEventListener('change', (e) => {
      if (e.target.checked) {
        submitDom.removeAttribute('disabled');
      } else {
        submitDom.setAttribute('disabled', true);
      }
    });

    // textarea文本域赋值
    const textarea = document.getElementById('detailedApplicationInfo');
    const hiddenInput = document.getElementById('textareaBox');

    // 监听 textarea 失去焦点事件
    textarea.addEventListener('blur', function () {
      hiddenInput.value = textarea.value.trim(); // 把内容赋值给 hidden input
    });

    // 文件上传
    let s3keys = [];
    let selectedFiles = [];
    const fileInput = document.getElementById('fileInput');
    const fileList = document.getElementById('fileList');
    const genTempId = () => '_' + Math.random().toString(36).substr(2, 9);

    // 上传文件
    fileInput.addEventListener('change', handleImageUpload);

    async function handleImageUpload(e) {
      const files = Array.from(e.target.files);
      if (!files.length) return;

      // 超过上限检查
      if (selectedFiles.length + files.length > 5) {
        const upload_more_error = document.querySelector('.csr-form jky-form').getAttribute('data-upload_more_error');
        pushErrorMessage(upload_more_error);
        e.target.value = null;
        return;
      }

      const allowedTypes = [
        'image/png', 'image/jpeg', 'image/jpg', 'image/webp',
        'application/pdf', 'image/svg+xml'
      ];

      const info = await getAwsS3Data();
      chooseLabel.classList.add('loading');

      for (const file of files) {
        // 类型检查
        if (!allowedTypes.includes(file.type)) {
          const upload_format_error = document.querySelector('.csr-form jky-form').getAttribute('data-upload_format_error');
          pushErrorMessage(upload_format_error);
          continue;
        }

        // 大小检查
        if (file.size > 10 * 1024 * 1024) {
          const upload_exceed_error = document.querySelector('.csr-form jky-form').getAttribute('data-upload_exceed_error');
          pushErrorMessage(upload_exceed_error);
          continue;
        }

        // 避免重复（同名文件）
        if (selectedFiles.find(f => f.file.name === file.name)) continue;

        // 上传到 S3
        try {
          const type = file.name.split('.').pop().toLowerCase();
          const uniqueName = `${genTempId()}-${Date.now()}.${type}`;

          const s3 = await uploadToS3(
            { file, filename: `csr-form/${uniqueName}` },
            info.data
          );

          // 上传成功
          const fileData = { id: genTempId(), file, s3: s3.Location };
          selectedFiles.push(fileData);
          s3keys.push(s3.Location);
          jpForm.querySelector('.file-value').value = s3keys;
        } catch (err) {
          console.error('上传失败:', err);
        }
      }

      e.target.value = null;
      chooseLabel.classList.remove('loading');
      renderFileList();
      updateUploadButtonState();
    }

    // 渲染文件列表
    function renderFileList() {
      fileList.querySelectorAll('.file-item').forEach(el => el.remove());
      const chooseDOM = document.querySelector('.csr-form .choose-btn');

      selectedFiles.forEach(({ file, id, s3 }, index) => {
        const item = document.createElement('div');
        item.className = 'file-item';
        item.innerHTML = `
      <div class="image">
        ${file.type === 'application/pdf'
            ? `<div class="pdf-icon flex">
                <svg width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#prefix__clip0_61_277)" fill="#666"><path d="M58 28.5v-8.844a4.001 4.001 0 00-1.169-2.831L41.17 1.169A3.987 3.987 0 0038.344 0H9a3 3 0 00-3 3v25.5c0 .275-.225.5-.5.5H1c-.55 0-1 .45-1 1v25c0 .55.45 1 1 1h5a8 8 0 008 8h41a3 3 0 003-3v-4c0-.55.45-1 1-1h4c.55 0 1-.45 1-1V30c0-.55-.45-1-1-1h-4.5a.501.501 0 01-.5-.5zM44 9.656L48.344 14H44.25a.25.25 0 01-.25-.25V9.656zM10.5 4H36c2.206 0 4 1.794 4 4v9c0 .55.45 1 1 1h9c2.206 0 4 1.794 4 4v6.5c0 .275-.225.5-.5.5h-43a.501.501 0 01-.5-.5v-24c0-.275.225-.5.5-.5zm43 56H14c-2.206 0-4-1.794-4-4h43.5c.275 0 .5.225.5.5v3c0 .275-.225.5-.5.5zm6-8h-55a.501.501 0 01-.5-.5v-18c0-.275.225-.5.5-.5h55c.275 0 .5.225.5.5v18c0 .275-.225.5-.5.5z"/><path d="M17.912 44.475v4.544h-2.781V35.98h4.494c3.243 0 4.868 1.375 4.868 4.125 0 1.338-.487 2.406-1.468 3.213-.982.806-2.207 1.193-3.675 1.156h-1.438zm0-6.337v4.212h1.206c1.632 0 2.45-.712 2.45-2.131 0-1.388-.806-2.081-2.425-2.081h-1.23zm9.431 10.887V35.981h4.507c4.63 0 6.943 2.119 6.943 6.356 0 2.013-.65 3.632-1.943 4.857-1.294 1.218-2.97 1.831-5.02 1.831h-4.487zm2.782-10.769v8.494h1.512c1.319 0 2.356-.394 3.106-1.181.75-.788 1.132-1.85 1.132-3.194 0-1.294-.394-2.306-1.182-3.038-.787-.725-1.806-1.087-3.062-1.087h-1.506v-.006zm18.868 0h-4.656v3.35h4.288v2.275h-4.288v5.144h-2.781V35.981h7.437v2.275z"/></g><defs><clipPath id="prefix__clip0_61_277"><path fill="#fff" d="M0 0h64v64H0z"/></clipPath></defs></svg>
              </div>`
            : `<img class="upload-image" src="${s3}" alt="uploaded image" />`
          }
        <div class="close" data-index="${index}" data-id="${id}" data-s3="${s3}">
          <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18a8.61 8.61 0 003.468-.707 9.26 9.26 0 002.873-1.948 9.155 9.155 0 001.952-2.872A8.642 8.642 0 0018 9a8.642 8.642 0 00-.707-3.473 9.155 9.155 0 00-1.952-2.872A9.258 9.258 0 0012.468.707 8.632 8.632 0 008.991 0a8.632 8.632 0 00-3.477.707A9.151 9.151 0 002.65 2.655 9.228 9.228 0 00.707 5.527 8.642 8.642 0 000 9c0 1.227.234 2.385.703 3.473a9.09 9.09 0 001.947 2.872 9.261 9.261 0 002.873 1.948A8.633 8.633 0 009 18z" fill="#666"/><path d="M6.003 12.655a.625.625 0 01-.458-.191.625.625 0 01-.191-.458c0-.184.065-.341.195-.471l2.526-2.526-2.526-2.517a.662.662 0 01-.195-.471.62.62 0 01.19-.463.632.632 0 01.459-.186c.178 0 .335.062.471.186L9.01 8.084l2.543-2.526a.632.632 0 01.463-.195c.177 0 .33.062.458.186a.62.62 0 01.19.463.662.662 0 01-.195.471L9.934 9.01l2.525 2.517c.13.124.196.284.196.48 0 .178-.064.33-.191.458a.636.636 0 01-.467.191.624.624 0 01-.472-.195L9.01 9.943 6.492 12.46a.664.664 0 01-.49.195z" fill="#fff"/></svg>
        </div>
      </div>
    `;
        chooseDOM.parentNode.insertBefore(item, chooseDOM);
      });

      // 删除事件
      document.querySelectorAll('.file-item .close').forEach(btn => {
        btn.addEventListener('click', async (e) => {
          const index = Number(e.currentTarget.dataset.index);
          const key = e.currentTarget.dataset.s3;
          await handleImageClear(key);
          selectedFiles.splice(index, 1);
          s3keys.splice(index, 1);
          renderFileList();
          jpForm.querySelector('.file-value').value = s3keys;
          updateUploadButtonState();
        });
      });
    }

    // 删除文件（S3）
    async function handleImageClear(key) {
      const info = await getAwsS3Data();
      const { access_key_id, secret_access_key, session_token, region, bucket } = info.data;
      const s3Client = new window.AWS.S3({
        accessKeyId: access_key_id,
        secretAccessKey: secret_access_key,
        sessionToken: session_token,
        region
      });
      await s3Client.deleteObject({ Bucket: bucket, Key: key });
    }

    // 上传按钮状态控制
    function updateUploadButtonState() {
      const uploadBtn = document.querySelector('.choose-btn');
      if (!uploadBtn) return;
      uploadBtn.disabled = selectedFiles.length >= 5;
      uploadBtn.classList.toggle('hidden', selectedFiles.length >= 5);
    }


    // 获取前一个兄弟节点的标题文本
    function getPreviousSiblingHeadingText() {
      // 找到当前csr-form-section元素
      const currentSection = document.querySelector('.csr-form-section');
      if (!currentSection) {
        return '未找到csr-form-section';
      }

      // 获取前一个兄弟节点
      let prevSibling = currentSection.previousElementSibling;

      // 遍历前面的兄弟元素，查找包含blocks-heading-content的组件
      while (prevSibling) {
        const headingContent = prevSibling.querySelector('.blocks-heading-content');
        if (headingContent) {
          const headingElement = headingContent.querySelector('.blocks-content-heading');
          if (headingElement) {
            return getResponsiveText(headingElement);
          }
        }
        prevSibling = prevSibling.previousElementSibling;
      }

      return '未找到前一个兄弟节点的标题';
    }

    // 获取响应式文本（区分PC和移动端）
    function getResponsiveText(element) {
      // 检查是否为移动端
      const isMobile = window.innerWidth < 1024;

      // 查找PC端文本（通常有hidden lg:block或类似的类）
      const pcTextElements = element.querySelectorAll('.hidden.lg\\:block, .lg\\:block.hidden, .hidden.lg\\:line-clamp-2, .lg\\:line-clamp-2.hidden');

      // 查找移动端文本（通常有block lg:hidden或类似的类）
      const mbTextElements = element.querySelectorAll('.block.lg\\:hidden, .lg\\:hidden.block');

      let text = '';

      if (isMobile && mbTextElements.length > 0) {
        // 移动端优先显示移动端文本
        text = mbTextElements[0].textContent.trim();
      } else if (!isMobile && pcTextElements.length > 0) {
        // PC端优先显示PC端文本
        text = pcTextElements[0].textContent.trim();
      } else if (pcTextElements.length > 0) {
        // 备选：PC端文本
        text = pcTextElements[0].textContent.trim();
      } else if (mbTextElements.length > 0) {
        // 备选：移动端文本
        text = mbTextElements[0].textContent.trim();
      } else {
        // 最后备选：直接获取元素文本
        text = element.textContent.trim();
      }

      return text || '无标题文本';
    }

    function toCsr(data) {
      if (data.response && data.response.code === 200) {
        const topDom = document.querySelector('.csr-form .csr-form-top')
        const bottomDom = document.querySelector('.csr-form .csr-form-bottom')
        topDom.classList.add('active');
        bottomDom.classList.add('active');
        const msg = document.querySelector('.csr-form jds-button')?.dataset.success || data.response.message;
        pushSuccessMessage(msg);
        // 获取前一个兄弟节点的标题文本
        const headingText = getPreviousSiblingHeadingText();
        const button_name = document.querySelector('.csr-form jds-button').textContent.trim()

        gaPushDataLayer('5.0_products_details_page_user_clicks', {
          "module": headingText ? headingText : 'Application Form',
          "button_name": button_name
        })
      }

    }
    window.toCsr = toCsr

  })
})();